import {CoreDI, ModuleIsEnabledFilter, Installer} from '@gongxigames/framework/core';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';
import {InfoModule} from '@gongxigames/framework/slotV2/modules/info';
import {getGameHistoryListHTML} from '@gongxigames/framework/slot';
import {GameOnlyEventMap, slotStore, strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export class GameHistoryInfoPage<T extends GameOnlyEventMap> extends InfoModule<T>{
    public static readonly NAME: symbol = Symbol('GameHistory');
    public static readonly isEnabled: ModuleIsEnabledFilter = (components: Installer) => {
        return components.getComponent<SlotSettings>(CoreDI.Settings).get('gameHistoryListEnabled') || false;
    };

    private _gameHistoryContainer!: HTMLElement;
    private _gameHistory!: HTMLElement;

    public init(): void {
        super.init();

        this.createPage();
    }

    protected onSetupEvents(): void {
        strictUiEmitter.on('UI.menu.historyButtonClicked', this.onPageClicked.bind(this));
        strictUiEmitter.on('Game.command.hideInfo', this.close.bind(this));
    }

    protected createPage(): void {
        this._gameHistoryContainer = document.createElement('div');
        this._gameHistoryContainer.id = 'gameHistoryContainer';
        document.body.appendChild(this._gameHistoryContainer);

        this._gameHistory = document.createElement('div');
        this._gameHistory.id = 'gameHistory';
        this._gameHistoryContainer.appendChild(this._gameHistory);
    }

    private onPageClicked(): void {
        const url = this._settings.get('historyUrl');

        if (!url) {
            return;
        }

        strictUiEmitter.emit('Game.command.round.uiDisabled', GameHistoryInfoPage.NAME);

        this._gameHistory.insertAdjacentHTML('afterbegin',
            getGameHistoryListHTML(this._languageService.get('gameHistory'), url));

        slotStore.infoSystemData.value.set(GameHistoryInfoPage.NAME, {
            name: GameHistoryInfoPage.NAME,
            content: this._gameHistoryContainer,
            title: this._languageService.get('gameHistory'),
            scroll: false
        });

        document.querySelector('#gameHistory iframe')!.addEventListener( 'load', () => {
            this.open();
        });
    }

    protected open(): void {
        this._gameHistoryContainer && strictUiEmitter.emit('UI.gameHistory.opened');
    }

    protected close(): void {
        this._gameHistoryContainer && strictUiEmitter.emit('UI.gameHistory.closed');
    }
}
